module.exports = __webpack_public_path__ + "img/Realisme_Fra_romantikk_til_realisme5.f222c709.jpg";